import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { MED_INFRACTIONS_ROUTE_PATHS } from './config';

export const MED_INFRACTIONS_ROUTES: TApplicationRoute[] = [
  {
    id: 'med-infractions',
    path: MED_INFRACTIONS_ROUTE_PATHS.medInfractions,
    component: lazy(() => import('./pages/med-infractions-page')),
    layout: 'default',
    permissions: { scopes: ['med-infractions'] },
    menu: {
      title: 'pages.fraud.medInfractions.menuTitle',
    },
  },
];
